var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"tabIndex":_vm.activeTab},on:{"change":_vm.setActiveTab}},[_c('Tab',{attrs:{"title":"Форма предзаявки"}},[_c('ProposalForm')],1),_c('Tab',{attrs:{"title":"Продукты","disabled":!_vm.isFormValid}},[_c('Products')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }